<script setup lang="ts">
  import BulletPoint from '../tips/BulletPoint.vue';
</script>

<template>
  <div>
    <p><BulletPoint />Prefixo obrigatório</p>
    <p><BulletPoint />Numeração de documento obrigatória</p>
    <p><BulletPoint />Sequencial obrigatória</p>
    <p>
      <BulletPoint />Utilizar as mesmas informações de um documento que já existe, gera uma nova
      revisão daquele documento
    </p>
  </div>
</template>
